module.exports = __webpack_public_path__ + "img/pic_youshi_01.f53215bb.png";